var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"iv-system iv-p-t-24"},[_c('div',{staticClass:"iv-main-width"},[_c('Tab',{attrs:{"navList":_vm.navList},on:{"on-click":_vm.tabClick}}),(_vm.list.length > 0)?_c('List',{staticClass:"iv-m-t-24",attrs:{"type":"system","showPage":true}}):_vm._e(),(_vm.list.length <= 0)?_c('NoData'):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }